/** @format */

import React, { useEffect } from "react";
import { Image } from "react-bootstrap";

export enum AvatarType {
  Custom = "Custom",
  Artist = "Artist",
  Genius = "Genius",
  Queen = "Queen",
  Professor = "Professor",
  Poet = "Poet",  
}
export const defaultAvatar = AvatarType.Artist;

type AvatarsProps = {
  type: AvatarType;
  width?: number;
  style?: object;
};
const avatarArray = ["Artist", "Genius", "Queen", "Professor", "Poet"];
export const importFile = (name: string, ext: string = "png") => {
  let src = { default: "" };
  try {
    src = require(`${name}.${ext}`);
  } catch (e) {}

  if (!src) {
    src = { default: "" };
  }

  if (typeof src === "string") {
    src = { default: src as unknown as string };
  }

  return src;
};

const Avatars = ({ type, width = 160, style }: AvatarsProps) => {  
 
  const src =
    type && !type.includes("http")
      ? importFile(
          `./The${type && avatarArray?.includes(type) ? type : defaultAvatar}`
        ).default
      : type ;
      // || "Founder";

      

  return (
    <Image
      width={width}
      roundedCircle={true}
      // srcSet={`${src} 4x`}
      src={src}
      onError={(e: any)=> {
        e.target.src = "https://placehold.jp/6352e8/6352e8/150x150.png"
      }}
      style={style}
      referrerPolicy="no-referrer"
      fluid
    />
  );
};

export default Avatars;
